module.exports = __webpack_public_path__ + "static/media/components.075ce507.png";